import React from 'react';
import '../Css_files/Homecontent.css';
import mainImg from '../Images/Home-content1.jpg';
import img2 from '../Images/Home-content2.jpg';

const HomeContent = () => {
  return (
    <div className="home-content-container">
      <div className="home-content-images">
        <div className="home-content-main-image">
          <img src={mainImg} alt="students learning online" />
        </div>
        <div className="home-content-side-images">
          <img src={img2} alt="interactive online class" />
        </div>
      </div>

      <div className="home-content-text">
        <h1>Learn Anytime, Build Your Future</h1>
        <p>
          At <strong>Profenaa Technologies Online Learning</strong>, we make education accessible for everyone. 
          Explore expert-led courses in <strong>Mechanical, Civil, Electrical & Electronics, IT & Computer Science, 
          and Arts & Multimedia</strong>.  
          <br /><br />
          Our platform blends engaging video lessons, practical projects, and industry-recognized certifications 
          to help you upgrade your skills — at your own pace, from anywhere in the world.
        </p>
        <button className="home-content-cta-button">Start Learning Now ↗</button>
      </div>
    </div>
  );
};

export default HomeContent;
